import ImagesOnboarding1Png from '@/public/images/onboarding/1.png';
import ImagesOnboarding2Png from '@/public/images/onboarding/2.png';
import ImagesOnboarding3Png from '@/public/images/onboarding/3.png';
import ImagesOnboarding4Png from '@/public/images/onboarding/4.png';
import ImagesOnboardingArrowRightPng from '@/public/images/onboarding/arrow-right.png';
import ImagesOnboardingArrowRightSvg from '@/public/images/onboarding/arrow-right.svg';

export {
  ImagesOnboarding1Png,
  ImagesOnboarding2Png,
  ImagesOnboarding3Png,
  ImagesOnboarding4Png,
  ImagesOnboardingArrowRightPng,
  ImagesOnboardingArrowRightSvg,
};
